import { all, fork } from 'redux-saga/effects';
import LoginReducers, { loginActions } from './login/redux/loginSlice';
import UserReducers from './user/redux/userSlice';
import TablesReducers from './tables/redux/tablesSlice';
import JobsReducers from './jobs/redux/jobsSlice';
import JobApplicationReducers from './jobApplication/redux/jobApplicationSlice';
import dashboardReducers from './dashboard/redux/dashboardSlice';
import organizationReducers from './organization/redux/organizationSlice';
import toolsReducers from './tools/redux/toolsSlice';
import reportsReducers from './reports/redux/reportsSlice';
import scheduleInterviewReducers from './scheduleInterview/redux/scheduleInterviewSlice';
import emailTemplatesReducers from './emailTemplates/redux/emailTemplatesSlice';
import { combineReducers, AnyAction } from '@reduxjs/toolkit';
import { loginSagas } from './login/saga';
import { userSagas } from './user/saga';
import { tablesSagas } from './tables/saga';
import { jobsSagas } from './jobs/saga';
import { jobApplicationSagas } from './jobApplication/saga';
import { dashboardSagas } from './dashboard/saga';
import { organizationsSagas } from './organization/saga';
import { toolsSagas } from './tools/saga';
import { reportsSagas } from './reports/saga';
import { scheduleInterviewSaga } from './scheduleInterview/saga';
import { emailTemplatesSagas } from './emailTemplates/saga';

const appReducer = combineReducers({
    login: LoginReducers,
    user: UserReducers,
    tables: TablesReducers,
    jobs: JobsReducers,
    jobApplication: JobApplicationReducers,
    dashboard: dashboardReducers,
    organization: organizationReducers,
    tools: toolsReducers,
    reports: reportsReducers,
    scheduleInterview: scheduleInterviewReducers,
    emailTemplates: emailTemplatesReducers,
});

type RootState = ReturnType<typeof appReducer>;

export const rootReducer = (
    state: RootState | undefined,
    action: AnyAction
) => {
    if (action.type === loginActions.logout.type) {
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};

export const rootSaga = function* () {
    yield all([
        fork(loginSagas),
        fork(userSagas),
        fork(tablesSagas),
        fork(jobsSagas),
        fork(jobApplicationSagas),
        fork(dashboardSagas),
        fork(organizationsSagas),
        fork(toolsSagas),
        fork(reportsSagas),
        fork(scheduleInterviewSaga),
        fork(emailTemplatesSagas),
    ]);
};

export * from './login/redux/index';
export * from './user/redux/index';
export * from './tables/redux/index';
export * from './jobs/redux/index';
export * from './jobApplication/redux/index';
export * from './dashboard/redux/index';
export * from './organization/redux/index';
export * from './tools/redux/index';
export * from './reports/redux/index';
export * from './scheduleInterview/redux/index';
export * from './emailTemplates/redux/index';
